import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArchive} from "@fortawesome/free-solid-svg-icons";

import "./SidebarNavItemArchiver.css";

const SidebarNavItemArchiver = ({projectId, handleOpenArchiveModal}) => {
  return (
    <div
      className="sidebar-nav-item-archive d-flex align-items-center justify-content-center"
      onClick={() => handleOpenArchiveModal(projectId)}
    >
      <FontAwesomeIcon
        className="sidebar-nav-item-archive-icon"
        icon={faArchive}
      />
    </div>
  );
};

export default SidebarNavItemArchiver;
